function caseInsensitiveMatchInner(a: string, b: string): boolean {
    return a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0;
}

export function caseInsensitiveMatch(a: string, b: string): boolean {
    // this is here due to compatibility with IE <10
    return caseInsensitiveMatchInner("a", "A") ? caseInsensitiveMatchInner(a, b) : a.toUpperCase() === b.toUpperCase();
}

//A bug in globalize.localize() means that it cannot return an empty string for non default cultures.
export function defaultToEmptyString(value: string): string {
    return value != null ? value : "";
}
